import { useMemo } from "react";

import { useTeamsListQuery } from "app/pages/sales-intelligence/modules/teams/queries/useTeamsListQuery";

type UseUserTeamMembershipParams = {
    enabled?: boolean;
};

export type UserTeamMembership = {
    userTeamIds: ReadonlySet<number>;
    isMembershipReady: boolean;
    isMembershipLoading: boolean;
    isMembershipSuccess: boolean;
};

export const useUserTeamMembership = ({ enabled = true }: UseUserTeamMembershipParams = {}): UserTeamMembership => {
    const {
        data: myTeams,
        isSuccess,
        isError,
    } = useTeamsListQuery({
        onlyMyTeams: true,
        enabled,
    });

    const userTeamIds = useMemo(() => new Set((myTeams ?? []).map((team) => team.teamId)), [myTeams]);

    return {
        userTeamIds,
        isMembershipReady: !enabled || isSuccess || isError,
        isMembershipLoading: enabled && !isSuccess && !isError,
        isMembershipSuccess: enabled && isSuccess,
    };
};
